<template src='../assets/html/nav.html'></template>
<style>
.rvheadermenu {
  margin-left: auto !important;
}

.rvheadermenu li {
  display: inline-block;
  list-style: none;
}

.rvheadermenu .button-dropdown {
  position: relative;
}

.rvheadermenu li a {
  cursor: pointer;
}

.rvheadermenu .dropdown-menu li {
  display: block;
}

.navbar-dark .navbar-nav .nav-link.active::after {
  border-top: 0.3em solid #EB0000 !important;
}

.rvheadermenu li .dropdown-menu {
  font-size: 16px;
  text-transform: capitalize;
  top: 85%;
  left: 0px;
}

.rvheadermenu > li:last-child {
  border-left: 1px solid #ddd;
  margin-left: 10px;
}

.rvheadermenu > li:last-child a:hover img {
  -webkit-filter: grayscale(0);
  filter: grayscale(0);
}

/* .rvheadermenu > li:last-child img {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
} */

.rvheadermenu > li:nth-of-type(2) > a > span {
  color: #EB0000 !important;
  background-color: transparent;
  border-bottom: solid 3px #EB0000;
}

.rvheadermenu > li:nth-of-type(2) .dropdown-menu > li:nth-of-type(1) > a {
  color: #fff;
  background-color: #EB0000;
}

.rvheadermenu
  > li:nth-of-type(2)
  .dropdown-menu
  > li:nth-of-type(1)
  > a
  > span {
  border-bottom: 1px solid #ffffff;
}

.navbar-default .navbar-nav li:last-child .nav-link:hover span {
  border-bottom: solid 0px #EB0000;
}

.rvheadermenu li .dropdown-menu.active {
  display: block;
}
</style>
<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";
import { SITE_URL } from "@/api/config";
import jQuery from "jquery";
import {
  LOGOUT_ACCOUNT,
  WON_HEADER_MENU,
  GET_LOGIN_HELP_TEXT
} from "@/store/actions.type";
export default {
  created() {
    this.keepMeLogin(),
      this.headermenu(),
      setTimeout(
        function() {
          this.menu();
        }.bind(this),
        2000
      );
    this.getloginText();
  },
  data() {
    return {
      wonheadermenu: "",
      userData: "",
      userName: "",
      site_url: SITE_URL
    };
  },
  computed: {
    displayheadermenu() {
      return this.$store.state.auth.headermenu;
    }
  },
  methods: {
    ...mapState({
      user: state => state.auth
    }),
    ...mapActions({
      logout: "LOGOUT_ACCOUNT",
      getmenu: "WON_HEADER_MENU",
      getloginText: "GET_LOGIN_HELP_TEXT"
    }),

    async headermenu() {
      var menu = this.getmenu();
      this.wonheadermenu = menu;
    },
    signout: function() {
      this.logout();
      window.location.reload(true);
    },
    keepMeLogin: function() {
      if (performance.navigation.type != 1) {
        if (localStorage.getItem("keepMe") == "false") {
          this.logout();
          window.location.reload(true);
        }
      }
    },
    menu: function() {
      jQuery(document).ready(function(e) {
        function t(t) {
          e(t).bind("click", function(t) {
            t.preventDefault();
            e(this)
              .parent()
              .fadeOut();
          });
        }
        e(".dropdown-toggle").click(function() {
          var t = e(this)
            .parents(".button-dropdown")
            .children(".dropdown-menu")
            .is(":hidden");
          e(".button-dropdown .dropdown-menu").hide();
          e(".button-dropdown .dropdown-toggle").removeClass("active");
          if (t) {
            e(this)
              .parents(".button-dropdown")
              .children(".dropdown-menu")
              .toggle()
              .parents(".button-dropdown")
              .children(".dropdown-toggle")
              .addClass("active");
          }
        });
        e(document).bind("click", function(t) {
          var n = e(t.target);
          if (!n.parents().hasClass("button-dropdown"))
            e(".button-dropdown .dropdown-menu").hide();
        });
        e(document).bind("click", function(t) {
          var n = e(t.target);
          if (!n.parents().hasClass("button-dropdown"))
            e(".button-dropdown .dropdown-toggle").removeClass("active");
        });
      });
    },

    setsignin: function() {
      if (
        this.user().user.username == "" ||
        this.user().user.username == "undefined"
      ) {
        this.userName = "Loading...";
      } else {
        this.userData = this.user();
        this.userName = "Hello, " + this.user().user.username;
      }
    }
  },

  beforeUpdate() {
    this.setsignin();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/TheNavbar.vue